import Coordinate from 'services/utils/Coordinate';

import L from 'leaflet';
import { useEffect } from 'react';
import { useMap } from 'views/MapView/hooks';

const useSaveAsLayer = () => {
  const { addLayer } = useMap();
  const saveAsLayer = (layerName, layerStyle, latlngMarker, setSaveModalOpen, resetForm, hadleRemoveMarker, Layer) => {
    let markerPoint = L.marker(latlngMarker);
    let markerPointGeoJSON = markerPoint.toGeoJSON();

    markerPointGeoJSON.properties.ID_GBA = 1;
    // Formatar para DMS (graus minutos segundos)
    const coordinates = [
      markerPointGeoJSON.geometry.coordinates[1],
      markerPointGeoJSON.geometry.coordinates[0],
    ];

    const dmsCoordinates = Coordinate.convertDDToDMS(coordinates);
    markerPointGeoJSON.properties['Latitude'] = dmsCoordinates[0];
    markerPointGeoJSON.properties['Longitude'] = dmsCoordinates[1];

    const customRender = L.canvas({ pane: 'mixedPane' });
    let options = {
      pane: 'mixedPane',
      renderer: customRender,
      style: layerStyle,
      pointToLayer: function (feature, latlng) {
        return L.circleMarker(latlng, {
          pane: 'mixedPane',
          ...layerStyle,
          renderer: customRender,
        });
      },
    };
    let geoJsonLayer = L.geoJSON(markerPointGeoJSON, options);
    let layerToAdd = new Layer(
      null,
      'criada',
      null,
      layerName,
      null,
      null,
      null,
      null,
      null
    );
    layerToAdd.setLeafletLayer(geoJsonLayer);
    layerToAdd.setLayerStyle(layerStyle);
    addLayer(layerToAdd);
    setSaveModalOpen(false);
    resetForm();

    // Remover o marcador do mapa
    hadleRemoveMarker();
  };

  // Criar outras funções aqui, se necessário

  useEffect(() => {
    // Pode adicionar lógica de efeito aqui, se necessário
  }, []); // Certifique-se de ajustar as dependências conforme necessário

  return saveAsLayer;
};

export default useSaveAsLayer;
